import { Component, Vue } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import AppHeaderNav from '@/layouts/app-header-layout/app-header-nav/app-header-nav.vue';
import { authAPI } from '@/providers/apis/auth/auth';
import RoleList from '@/components/cards/role-list/role-list';
import { NAV_MENU_LIST, DEMO_TENANT_ID } from '@/utils/constants';
import { demoUser } from '@/providers/apis/demo-user/demo-user';
import StaticAssetsMixin from '@/helpers/mixins/static-assets-mixin';

@Component({
  components: {
    AppHeaderNav,
    RoleList,
  },
})
export default class AppHeaderLayout extends Vue {

  // -------------------------------------------------------------------------
  // Properties

  private currentRouteName: string = 'dashboard';

  private appList: any = [];

  private headerLogo: any = null;

  private demoTenantId: string = DEMO_TENANT_ID;

  private tenantId: string = this.$access.getTenantId();

  // -------------------------------------------------------------------------
  // Computed Properties
  /**
   * @returns {boolean} isDemoUser help to show the user role list
   */
  private isShowRole: boolean = false;

  private get isHideRoleMenu() {
    return this.session && this.session!.isHideRoleMenu ? this.session!.isHideRoleMenu : false;
  }

  /**
   * It will fetch current session object.
   * @return {SessionModel}
   */
  get session() {
    return sessionService.getSession();
  }

  public get logoUrl() {
    return this.$access.getAssets(null, 'logo');
  }

  public get isMygooru() {
    const isMygooru = new StaticAssetsMixin().isMygooruHost();
    return isMygooru;
  }

  public get isFacet() {
    const isFacet = localStorage.getItem('isFacet');
    return isFacet === 'true';
  }
  private get isCompetency() {
    return this.$router.currentRoute && this.$router.currentRoute.query &&
      this.$router.currentRoute.query.isCompetency ? this.$router.currentRoute.query.isCompetency : false;
  }
  private mounted() {
    const currentRoutePath = this.$router.currentRoute.path;
    this.headerLogo =  sessionService.getTenantLogo();
    this.setCurrentRouteName(currentRoutePath);
    authAPI.setImpersonateToken(this.session && this.session.access_token);
    demoUser.userAppList().then((appList) => {
      this.appList = appList;
    });
  }
  // -------------------------------------------------------------------------
  // Actions

  private setCurrentRouteName(currentRoutePath: string) {
    const selectedMenuItems = NAV_MENU_LIST.filter((menuItem: any, index: any) => {
      return menuItem.path === currentRoutePath ? menuItem : null;
    });
    const selectedMenuItem = selectedMenuItems[0];
    if (selectedMenuItem) {
      this.currentRouteName = selectedMenuItem.name;
    }
  }

  private doLogout() {
    authAPI.signOut().then(() => {
      sessionService.deleteSession();
      this.$router.push('/login');
    });
  }

  private closeAppNav() {
    (this.$refs.appSideNav as HTMLFormElement).style.width = '0px';
  }

  private openAppNav() {
    (this.$refs.appSideNav as HTMLFormElement).style.width = '300px';
  }


  private goSupport() {
    window.open('http://support.gooru.org/', '_blank');
  }

}
